<template>
    <v-app relative class="login-registration">
        <v-layout class="b2b-slider">
            <v-carousel
                hide-delimiters
            >
                <v-carousel-item
                    v-for="(item,i) in items"
                    :key="i"
                    :interval="3000"
                    :src="item.src"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                ></v-carousel-item>
            </v-carousel>
        </v-layout>
        <v-flex class="b2b-green-circle">
        </v-flex>
        <v-container py-5 grid-list-lg>
            <div class="b2b-login-tabs text-center pt-0">
                <h1>Пользователям и партнерам</h1>
                <div class="policy-wrapper text-center">
                    Если вы хотите оформить полис для себя, то <a class="policy" target="_blank" href="https://getpolis.ru">перейдите по ссылке</a>
                </div>
            </div>
            <v-tabs
                v-if="step === 'login'"
                v-model="activeTab"
                class="b2b-login-tabs pt-5"
                centered
            >
                <v-tabs-slider color="green"></v-tabs-slider>
                <v-tab href="#tab-login">
                    <h2 class="pt-5 pb-5">Вход</h2>
                </v-tab>
                <v-tab href="#tab-registration" v-if="showRegistrationTab">
                    <h2 class="pt-5 pb-5">Регистрация</h2>
                </v-tab>

                <v-tab-item
                    :value="'tab-login'"
                >
                    <v-content>
                        <v-form ref="login" v-model="valid" class="login-form">
                            <v-container>

                                <p class="pt-5 pb-3" style="font-size: 18px">Введите e-mail, который вы указали при регистрации.</p>

                                <v-layout row wrap pb-2>
                                    <v-flex xs12 pt-0>
                                        <v-text-field
                                            v-model="email"
                                            :rules="[rules.required, rules.email]"
                                            label="E-mail"
                                            validate-on-blur
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            :type="showPass ? 'text' : 'password'"
                                            v-model="password"
                                            :rules="[rules.required]"
                                            label="Пароль"
                                            validate-on-blur
                                            required
                                            :autocomplete="'off'"
                                        >
                                            <template v-slot:append>
                                                <v-icon class="material-symbols-outlined pointer" @mousedown.stop.prevent="showPass = !showPass">
                                                    {{ showPass ? 'visibility' : 'visibility_off' }}
                                                </v-icon>
                                            </template>
                                        </v-text-field>
                                        <v-checkbox v-show="false"
                                            label="Запомнить меня"
                                            v-model="remember"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>


                                <v-layout pt-5 pb-2 row wrap>
                                    <v-flex xs12>
                                        <v-checkbox
                                            v-model="loginApproved"
                                            :rules="[rules.approvePrivacyPolicy]"
                                            validate-on-blur
                                        >
                                            <template v-slot:label>
                                                <div class="policy-wrapper">
                                                    При входе я принимаю
                                                    <a class="policy" target="_blank" href="https://getpolis.ru/public-offer">
                                                        условия договора
                                                    </a>
                                                    и соглашаюсь с
                                                        <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">
                                                            Политикой обработки персональных данных
                                                        </a>
                                                        и даю
                                                        <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                                            <br/>Согласие на обработку персональных данных
                                                        </a>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>

                                <v-layout pb-5 row wrap>
                                    <v-flex xs12>
                                        <v-btn @click="submit"
                                            :disabled="false"
                                            class="submit-button block element-center">Войти</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <a class="btn-link text-center" href="/password/recovery">Забыли пароль?</a>
                                    </v-flex>
                                </v-layout>

                            </v-container>
                        </v-form>
                    </v-content>
                </v-tab-item>

                <v-tab-item
                    v-if="showRegistrationTab"
                    :value="'tab-registration'"
                >
                    <v-content>
                        <v-form ref="registration" v-model="valid"  class="registration-form">
                            <v-container>

                                <h3 class="pt-5 pb-4">Ваши данные</h3>

                                <v-layout row wrap>
                                    <v-flex xs12 md12 lg6 py-0>
                                        <osago-name
                                            v-model="fio.surname"
                                            label="Фамилия"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md12 lg6 py-0>
                                        <osago-name
                                            v-model="fio.name"
                                            label="Имя"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md12 lg6 py-0>
                                        <osago-name
                                            v-model="fio.patronymic"
                                            label="Отчество"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md12 lg6 py-0>
                                        <osago-city-dadata :model="city"></osago-city-dadata>
                                    </v-flex>
                                    <v-flex xs12 md12 lg6 pt-0>
                                        <v-text-field
                                            v-model="user.email"
                                            :rules="[rules.email]"
                                            label="Е-mail (является логином)"
                                            validate-on-blur
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12 lg6 py-0>
                                        <v-text-field
                                            v-model="user.phone"
                                            :rules="[rules.phone]"
                                            mask="+7 ### ### ## ##"
                                            label="Телефон"
                                            validate-on-blur
                                            required
                                            ref="phoneNumber"
                                            @input="inputPhone"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12 lg12 py-0>
                                        <v-layout row wrap v-show="showPhoneCodeInput">
                                            <v-flex xs7>
                                                <v-text-field
                                                    v-model="validatePhoneCode"
                                                    :rules="[rules.phoneCode, validatePhone]"
                                                    mask="#####"
                                                    label="Введите код из СМС"
                                                    validate-on-blur
                                                    required
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs5 class="small-button-block">
                                                <v-btn
                                                    @click="sendPhoneCode"
                                                    :disabled="false"
                                                    class="small-button block"
                                                >
                                                    Отправить Код
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                                <v-layout pt-5 pb-5 row wrap>
                                    <v-flex xs12>
                                        <v-checkbox
                                            v-model="registrationApproved"
                                            :rules="[rules.approvePrivacyPolicy]"
                                            validate-on-blur
                                        >
                                            <template v-slot:label>
                                                <div class="policy-wrapper">
                                                    При регистрации я принимаю <a class="policy" target="_blank" href="https://getpolis.ru/public-offer">условия договора</a> и соглашаюсь с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">Политикой обработки персональных данных</a>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn @click="validateRegistration"
                                            :disabled="false"
                                            class="submit-button register-button block element-center">Зарегистрироваться</v-btn>
                                    </v-flex>
                                </v-layout>

                                <h2 class="pt-5 pb-3">Возникли вопросы?</h2>
                                <v-layout row wrap pb-5>
                                    <v-flex xs12 sm9 md8 lg7 py-0>
                                        <h3><a href="tel:88002010643">8 800 201 06 43</a></h3>
                                        <p style="font-size: 18px">Звоните, и наши менеджеры прояснят все моменты.</p>
                                    </v-flex>
                                </v-layout>

                            </v-container>
                        </v-form>
                    </v-content>
                </v-tab-item>
            </v-tabs>
            <div
                v-else-if="step === 'verify'"
                class="b2b-login-verify"
            >
                <b2b-login-verify
                    :email="verifyEmail"
                    :phone="verifyPhone"
                    :method="twoFactorMethod"
                />
            </div>
        </v-container>
    </v-app>
</template>

<script>
    import ymMixin from '../../mixins/ym';

    export default {
        mixins: [ymMixin],
        data: () => ({
            valid: true,
            email: '',
            password: '',
            remember: true,
            validatePhone: true,
            validatePhoneCode: '',
            showPhoneCodeInput: false,
            loginApproved: false,
            registrationApproved: false,
            activeTab: 'tab-login',

            user: {
                phone: '+7',
                email: '',
                is_egarant: false,
                egarant_company: 0
            },
            fio: {
                name: '',
                surname: '',
                patronymic: '',
            },
            city: {
                city: '',
                search: '',
                city_kladr: null,
                city_fias: null
            },

            items: [
                {
                    src: '/img/b2b_slider/macbook.png',
                },
                {
                    src: '/img/b2b_slider/ipad.png',
                },
                {
                    src: '/img/b2b_slider/iphone.png',
                },
            ],

            rules: {
                required: v => !!v || 'Обязательное поле',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
                phoneCode: v=> /^\d{5}$/.test(v) || 'Неверный формат',
                approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
            },

            showPass: false,
            showRegistrationTab: false,
            step: 'login',
            verifyEmail: null,
            verifyPhone: null,
            twoFactorMethod: 'email',
        }),

        mounted() {
            let params = new URLSearchParams(window.location.search);
            const hasRegistration = params.get("registration") === "true";

            if (hasRegistration) {
                this.activeTab = 'tab-registration';
                this.showRegistrationTab = true;
            } else {
                this.activeTab = 'tab-login';
                this.showRegistrationTab = false;
            }
            document.addEventListener('keydown', this.onKeyDown)
        },

        methods: {
            submit() {
                if (this.$refs.login.validate()) {
                    this.submitForm();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.')
                        this.goToFirstError()
                    });
                }
            },

            updateCsrfToken(token) {
                const meta = document.head.querySelector('meta[name="csrf-token"]');
                if (meta) {
                    meta.setAttribute('content', token);
                }

                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            },

            submitForm() {
                axios.post('/login', {
                    email: this.email,
                    password: this.password,
                    loginApproved: this.loginApproved,
                    remember: this.remember
                }).then(response => {
                    const data = response.data;

                    if (data.csrf_token) {
                        this.updateCsrfToken(data.csrf_token);
                    }

                    if (!data.login_success) {
                        PNotify.error('Ошибка авторизации');
                        return;
                    }

                    if (!data.two_factor_required) {
                        window.location.href = '/dashboard';
                        return;
                    }

                    this.step = 'verify';

                    this.verifyEmail = data.email;
                    this.verifyPhone = data.phone;
                    this.twoFactorMethod = data.used_channel;

                }).catch(error => {
                    console.log(error.response)
                    if (error.response.status === 422) {
                        PNotify.error('Введен неверный логин или пароль. Проверьте правильность введенных данных.')
                    } else if (error.response.status === 419) {
                        window.location.reload()
                    } else {
                        PNotify.error(error.response.data.message)
                    }
                });
            },

            validateRegistration() {
                if (this.$refs.registration.validate()) {
                    this.checkCode();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.')
                        this.goToFirstError(true)
                    });
                }
            },

            goToFirstError(registrationForm = false) {
                this.$vuetify.goTo( registrationForm ? '.registration-form .error--text' : '.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            checkCode(){
                axios.post('/create-pin/verify', {
                    phone: this.user.phone,
                    code: this.validatePhoneCode,
                }).then(response => {
                    this.submitRegistration()
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                })
            },

            submitRegistration() {
                let user = _.clone(this.user);
                if (this.user.egarant_company === 0) {
                    user.egarant_company = null;
                }

                axios.post('/register/agent', {
                    user: user,
                    fio: this.fio,
                    city: this.city,
                    isJuridical: null,
                    registrationApproved: this.registrationApproved,
                    bySelf: true
                }).then(response => {
                    this.reachGoal('sendRegistrationForm-B2B');
                    window.location.href = response.data.redirectTo;
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                });
            },

            inputPhone() {
                this.showPhoneCodeInput = this.$refs.phoneNumber.validate()
            },

            sendPhoneCode() {
                axios.post('/create-pin/registration', {
                    phone: this.user.phone,
                }).then(response => {
                    PNotify.success('Код отправлен');
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                })
            },
            onKeyDown(e) {
                if (e.key === 'Enter') {
                    this.submit();
                }
            }
        }
    }
</script>

<style scoped>
h3 a{
    color: #000;
    text-decoration: none;
}
h3 a:hover{
    color: #000;
    text-decoration: none;
}
.login-registration {
    overflow: hidden;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important ;

    height: 65px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    padding: 0 100px;
    line-height: 1.1;
}

@media (max-width: 480px) {
    .submit-button >>> .v-btn__content {
        font-size: 16px !important;
    }

    .register-button >>> .v-btn__content {
        padding: 0 30px;
    }
}

.small-button-block {
    display: flex;
    align-items: center;
}

.small-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 40px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;

    padding: 0 20px;
}

.btn-link {
    padding: 20px 10px 0;
    display: block;
}

h1 {
    font-size: 48px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

h2 {
    font-size: 35px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

.saparate-tabs {
    font-size: 35px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ .v-tabs__item {
    text-transform: none !important;
}

.text-center {
    text-align: center;
}

.element-center {
    margin-left: auto;
    margin-right: auto;
    display: block;
}

.pointer {
    cursor: pointer;
}

@media (max-width: 480px) {
    .v-input .v-label {
        font-size: 14px;
    }
}
</style>
<style>

.b2b-login-tabs .v-tabs__div .v-tabs__item{
    text-decoration: none;
}

.btn-link, .policy-wrapper a{
    color: #00ba57;
}
.btn-link:hover, .policy-wrapper a:hover{
    color: #00ba57;
    text-decoration: none;
}

@media (min-width: 961px) {
    .application--wrap {
        min-height: 1105px;
    }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    filter:none;
}

.v-text-field .v-input__append-inner {
    width: 56px;
    padding-left: 0;
}
.v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner {
    padding: 18px 18px;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/Login.vue